import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import {Flex} from "reflexbox";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import {IncorrectGuesses} from "./FreeText";
import {ANALAGOUSCOLOR1} from "../helpers/ThemeSettings";
import CardMedia from "@mui/material/CardMedia";

const MultipleChoice = (props) => {
  const {error, setError, userActions, pastAnswers, setUserAnswer, setDisableSubmit, initialCards, initialImages, complete} = props;
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    //set submit button to disabled if nothing selected
    setDisableSubmit(!selected);
  }, [selected]);

  useEffect(() => {
    //deselect cards after a user submits an answer
    setSelected(null);
  }, [pastAnswers]);

  //colors
  const startColor = '#d9efed45';
  const selectedColor = '#d9efed45d';
  const cardStyle = {
    padding: '8px',
    textAlign: 'center',
    minHeight: '59px',
  };
  const cardWrapperStyle = {
    width: '50%', padding: '8px', boxSizing: 'border-box'
  };

  const imageCardHeight='76.5px';

  return (<>
    <Flex style={{flexWrap: 'wrap'}}>
      {initialCards.map((el, index) => {
        const disabled = pastAnswers.includes(el);
        return <div key={index}
                    onClick={() => {
                      if (!complete) {
                        if (!disabled) {
                          const newSelected = selected === el ? null : el;
                          setSelected(newSelected);
                          setUserAnswer(newSelected);
                          error && setError(false);
                        }
                      }
                    }}
                    style={cardWrapperStyle}>
          {initialImages && <Card id={'image card'} style={{width: '100%', height: imageCardHeight}}>
            <CardMedia
              component="img"
              image={initialImages[index]}
              title={'image'}
              height={imageCardHeight}
              />
          </Card>}
          <Card
                style={{
                  ...cardStyle,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  boxSizing: 'border-box',
                  height: imageCardHeight,
                  backgroundColor: el === selected ?
                    selectedColor : disabled ? "darkgray" : startColor ,
                  border: el === selected ? '5px solid ' + ANALAGOUSCOLOR1 : '1px solid #d8d6d6',
                }}>
            <Typography style={{ fontWeight: el === selected && 'bold'}}>{el}</Typography>
          </Card>
        </div>
      })}
    </Flex>
    <Flex style={{justifyContent: 'center', alignItems: 'center', width: '100%', flexDirection: 'column'}}>
      {error &&
      <Typography variant={'contained'} color={'secondary'} style={{margin: '8px'}}> Incorrect! Try again</Typography>}
      <Typography variant={'caption'}>{IncorrectGuesses(userActions, pastAnswers)}</Typography>
    </Flex>
  </>)
};

MultipleChoice.propTypes = {
  error: PropTypes.any.isRequired,
  setError: PropTypes.func.isRequired,
  initialCards: PropTypes.array.isRequired,
  userActions: PropTypes.array.isRequired,
  pastAnswers: PropTypes.array.isRequired,
  setUserAnswer: PropTypes.func.isRequired,
  setDisableSubmit: PropTypes.func.isRequired,
  complete: PropTypes.any.isRequired,
};

export default MultipleChoice;